type Params = Record<string, string | number | undefined>;

export const queryKeys = {
  session: ['session'] as const,
  documents: {
    all: ['documents'] as const,
    list: (p: Params) => [...queryKeys.documents.all, 'list', p] as const,
    facets: () => [...queryKeys.documents.all, 'facets'] as const,
    detail: (id: string) => [...queryKeys.documents.all, 'detail', id] as const,
    whatChanged: (id: string) => [...queryKeys.documents.all, 'what-changed', id] as const,
    brief: (id: string) => [...queryKeys.documents.all, 'brief', id] as const,
  },
  houseViews: {
    all: ['house-views'] as const,
    list: () => [...queryKeys.houseViews.all, 'list'] as const,
    one: (instrument: string) => [...queryKeys.houseViews.all, 'one', instrument] as const,
  },
  forecasts: {
    all: ['forecasts'] as const,
    list: (p: Params) => [...queryKeys.forecasts.all, 'list', p] as const,
    instruments: () => [...queryKeys.forecasts.all, 'instruments'] as const,
  },
  ingestion: {
    all: ['ingestion'] as const,
    summary: () => [...queryKeys.ingestion.all, 'summary'] as const,
    series: () => [...queryKeys.ingestion.all, 'series'] as const,
    documents: (p: Params) => [...queryKeys.ingestion.all, 'documents', p] as const,
  },
  drafts: {
    all: ['drafts'] as const,
    list: (p: Params) => [...queryKeys.drafts.all, 'list', p] as const,
    preview: (text: string) => [...queryKeys.drafts.all, 'preview', text] as const,
  },
  whatsNew: (since: string) => ['whats-new', since] as const,
  evals: () => ['evals'] as const,
  feedback: {
    all: ['feedback'] as const,
    list: (p: Params) => [...queryKeys.feedback.all, 'list', p] as const,
    counts: () => [...queryKeys.feedback.all, 'counts'] as const,
  },
  desk: {
    all: ['desk'] as const,
    list: (p: Params) => [...queryKeys.desk.all, 'list', p] as const,
    one: (id: string) => [...queryKeys.desk.all, 'one', id] as const,
  },
  audit: {
    all: ['audit'] as const,
    list: (p: Params) => [...queryKeys.audit.all, 'list', p] as const,
  },
  users: {
    all: ['users'] as const,
    list: (p: Params) => [...queryKeys.users.all, 'list', p] as const,
    summary: () => [...queryKeys.users.all, 'summary'] as const,
    one: (id: number) => [...queryKeys.users.all, 'one', id] as const,
    lists: (id: number) => [...queryKeys.users.all, 'lists', id] as const,
  },
  subscribers: {
    all: ['subscribers'] as const,
    lists: () => [...queryKeys.subscribers.all, 'lists'] as const,
    list: (p: Params) => [...queryKeys.subscribers.all, 'list', p] as const,
  },
} as const;
